import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from 'semantic-ui-react';
import { TranslatableString } from '@rjsf/utils';
function IconButton(props) {
    const { icon, iconType, color, className, uiSchema, registry, ...otherProps } = props;
    return (_jsx(Button, { icon: icon, size: iconType, color: color, className: className, ...otherProps }));
}
export default IconButton;
export function CopyButton(props) {
    const { registry: { translateString }, } = props;
    return _jsx(IconButton, { title: translateString(TranslatableString.CopyButton), ...props, icon: 'copy' });
}
export function MoveDownButton(props) {
    const { registry: { translateString }, } = props;
    return _jsx(IconButton, { title: translateString(TranslatableString.MoveDownButton), ...props, icon: 'angle down' });
}
export function MoveUpButton(props) {
    const { registry: { translateString }, } = props;
    return _jsx(IconButton, { title: translateString(TranslatableString.MoveUpButton), ...props, icon: 'angle up' });
}
export function RemoveButton(props) {
    const { registry: { translateString }, } = props;
    return _jsx(IconButton, { title: translateString(TranslatableString.RemoveButton), ...props, icon: 'trash' });
}
//# sourceMappingURL=IconButton.js.map